import {IDataModel} from './../services/IDataModel';
import {IDataFilter} from './../services/DataTable';
import {Http, URLSearchParams, RequestOptions} from '@angular/http';
import * as _ from "lodash";
import {Injectable} from "@angular/core";

export enum RoleTypes {
    OWNER = 1,
    ACCOUNTING_SPECIALIST = 2,
    GENERAL_DIRECTOR_OF_SALES = 3,
    HEAD_OF_UNDERWRITING = 4,
    GENERAL_HEAD_OF_COLLECTIONS = 5,
    DIRECTOR_OF_SALES = 6,
    UNDERWRITER = 7,
    DATA_ENTRY = 8,
    COLLECTOR = 9,
    LEAD_GEN_MANAGER = 10,
    OUTSIDE_SALES_MANAGER = 11,
    FUNDING_SPECIALIST = 12,
    LEAD_GENERATOR = 13,
    REFERRAL_PARTNER_OPENER = 14,
    REFERRAL_AGENT_OPENER = 15,
}


export interface IRoleModel {
    id?: number,
    name: string,
}

@Injectable()
export class Roles implements IDataModel {

    private API_ROOT:string = '/roles';

    constructor(private http: Http) {}

    getList(filter: IDataFilter) {
        let params: URLSearchParams = new URLSearchParams();
        for(let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http.get(this.API_ROOT, new RequestOptions({
            search: params
        }))
    }

    getOne(id: number) {
        return this.http.get(`${this.API_ROOT}/${id}`)
    }

    add (fields: IRoleModel) {
        return this.http.post(this.API_ROOT, fields)
    }

    edit (id: number, fields: IRoleModel) {
        return this.http.put(`${this.API_ROOT}/${id}`, fields)
    }

    remove(id: number) {
        return this.http.delete(`${this.API_ROOT}/${id}`)
    }

    updateUserRole(userId: number, role: RoleTypes, companyIds: number[]) {
        return this.http.post(`/user/${userId}/role`, {
            role: role,
            company_ids: companyIds
        })
    }
    
    public getRoles(){
        return [
            {'id': RoleTypes.OWNER, 'name': 'Owner'},
            {'id': RoleTypes.ACCOUNTING_SPECIALIST, 'name': 'Accounting specialist'},
            {'id': RoleTypes.GENERAL_DIRECTOR_OF_SALES, 'name': 'General director of sales'},
            {'id': RoleTypes.HEAD_OF_UNDERWRITING, 'name': 'Head of Underwriting'},
            {'id': RoleTypes.GENERAL_HEAD_OF_COLLECTIONS, 'name': 'General head of collections'},
            {'id': RoleTypes.DIRECTOR_OF_SALES , 'name': 'Director of sales'},
            {'id': RoleTypes.UNDERWRITER, 'name': 'Underwriter'},
            {'id': RoleTypes.DATA_ENTRY, 'name': 'Data Entry'},
            {'id': RoleTypes.COLLECTOR , 'name': 'Collector'},
            {'id': RoleTypes.LEAD_GEN_MANAGER , 'name': 'Lead gen manager'},
            {'id': RoleTypes.OUTSIDE_SALES_MANAGER , 'name': 'Outside sales manager'},
            {'id': RoleTypes.FUNDING_SPECIALIST , 'name': 'Funding specialist'},
            {'id': RoleTypes.LEAD_GENERATOR, 'name': 'Lead generator'},
            {'id': RoleTypes.REFERRAL_PARTNER_OPENER, 'name': 'Referral Partner'},
            {'id': RoleTypes.REFERRAL_AGENT_OPENER, 'name': 'Referral Agent'},
        ];
    }

    public getNameByType(type): string {
        return _.find(this.getRoles(), {id: type}).name;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/roles.ts